




import { Component, Vue } from 'vue-property-decorator';

@Component
export default class extends Vue {

  public mounted () {
    this.init();
  }

  public async init() {
    localStorage.clear();
    location.href = "/";
  }

}
